/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddMenuItemRequest } from '../model';
// @ts-ignore
import { CopyMenuRequest } from '../model';
// @ts-ignore
import { MenuItemResponse } from '../model';
/**
 * AdminMenuControllerApi - axios parameter creator
 * @export
 */
export const AdminMenuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} menuId 
         * @param {AddMenuItemRequest} addMenuItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuItemToMenu: async (menuId: string, addMenuItemRequest: AddMenuItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('addMenuItemToMenu', 'menuId', menuId)
            // verify required parameter 'addMenuItemRequest' is not null or undefined
            assertParamExists('addMenuItemToMenu', 'addMenuItemRequest', addMenuItemRequest)
            const localVarPath = `/admin/menus/{menuId}/menu-items`
                .replace(`{${"menuId"}}`, encodeURIComponent(String(menuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMenuItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {CopyMenuRequest} copyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyPlanMenu: async (planId: string, copyMenuRequest: CopyMenuRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('copyPlanMenu', 'planId', planId)
            // verify required parameter 'copyMenuRequest' is not null or undefined
            assertParamExists('copyPlanMenu', 'copyMenuRequest', copyMenuRequest)
            const localVarPath = `/admin/plans/{planId}/menus/copy`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} menuId 
         * @param {string} menuItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuItemFromMenu: async (menuId: string, menuItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('deleteMenuItemFromMenu', 'menuId', menuId)
            // verify required parameter 'menuItemId' is not null or undefined
            assertParamExists('deleteMenuItemFromMenu', 'menuItemId', menuItemId)
            const localVarPath = `/admin/menus/{menuId}/menu-items/{menuItemId}`
                .replace(`{${"menuId"}}`, encodeURIComponent(String(menuId)))
                .replace(`{${"menuItemId"}}`, encodeURIComponent(String(menuItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMenuControllerApi - functional programming interface
 * @export
 */
export const AdminMenuControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMenuControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} menuId 
         * @param {AddMenuItemRequest} addMenuItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMenuItemToMenu(menuId: string, addMenuItemRequest: AddMenuItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MenuItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMenuItemToMenu(menuId, addMenuItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planId 
         * @param {CopyMenuRequest} copyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyPlanMenu(planId: string, copyMenuRequest: CopyMenuRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyPlanMenu(planId, copyMenuRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} menuId 
         * @param {string} menuItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMenuItemFromMenu(menuId: string, menuItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMenuItemFromMenu(menuId, menuItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMenuControllerApi - factory interface
 * @export
 */
export const AdminMenuControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMenuControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} menuId 
         * @param {AddMenuItemRequest} addMenuItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuItemToMenu(menuId: string, addMenuItemRequest: AddMenuItemRequest, options?: any): AxiosPromise<MenuItemResponse> {
            return localVarFp.addMenuItemToMenu(menuId, addMenuItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planId 
         * @param {CopyMenuRequest} copyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyPlanMenu(planId: string, copyMenuRequest: CopyMenuRequest, options?: any): AxiosPromise<void> {
            return localVarFp.copyPlanMenu(planId, copyMenuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} menuId 
         * @param {string} menuItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuItemFromMenu(menuId: string, menuItemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMenuItemFromMenu(menuId, menuItemId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMenuControllerApi - object-oriented interface
 * @export
 * @class AdminMenuControllerApi
 * @extends {BaseAPI}
 */
export class AdminMenuControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} menuId 
     * @param {AddMenuItemRequest} addMenuItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMenuControllerApi
     */
    public addMenuItemToMenu(menuId: string, addMenuItemRequest: AddMenuItemRequest, options?: AxiosRequestConfig) {
        return AdminMenuControllerApiFp(this.configuration).addMenuItemToMenu(menuId, addMenuItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planId 
     * @param {CopyMenuRequest} copyMenuRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMenuControllerApi
     */
    public copyPlanMenu(planId: string, copyMenuRequest: CopyMenuRequest, options?: AxiosRequestConfig) {
        return AdminMenuControllerApiFp(this.configuration).copyPlanMenu(planId, copyMenuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} menuId 
     * @param {string} menuItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMenuControllerApi
     */
    public deleteMenuItemFromMenu(menuId: string, menuItemId: string, options?: AxiosRequestConfig) {
        return AdminMenuControllerApiFp(this.configuration).deleteMenuItemFromMenu(menuId, menuItemId, options).then((request) => request(this.axios, this.basePath));
    }
}

